import styles from '../../styles/Player.module.scss';
import ReactPlayer from 'react-player';
import { useState, useRef, useEffect } from 'react';
import { useMobile } from '../../utils/useMobile';

const Player = ({ url, width = '1086px' }) => {
  const [isWatching, setIsWatching] = useState(false);
  const [volume, setVolume] = useState(
    typeof window !== 'undefined' && sessionStorage.getItem('vol')
      ? parseFloat(sessionStorage.getItem('vol'))
      : 0.5
  );
  const playerRef = useRef(null);
  const { isMobile } = useMobile();
  typeof window !== 'undefined' && sessionStorage.setItem('vol', volume);

  const handleWatching = () => {
    setIsWatching(!isWatching);
  };
  const handleVolume = () => {
    const internalPlayer = playerRef.current.getInternalPlayer();
    internalPlayer.addEventListener('volumechange', () => {
      setVolume(internalPlayer.volume);
      sessionStorage.setItem('vol', internalPlayer.volume);
    });
  };

  return (
    <>
      <div
        className={
          width === '1440px'
            ? `${styles.playerContainer} ${styles.playerContainerBig}`
            : styles.playerContainer
        }
        onClick={isMobile ? handleWatching : undefined}
      >
        <div
          className={isWatching ? styles.inactivePlayButton : styles.playButton}
          onClick={handleWatching}
        >
          {!isMobile && <img src={'/play.svg'} onClick={handleWatching} />}
        </div>

        <ReactPlayer
          width={'100%'}
          height='auto'
          controls
          ref={playerRef}
          volume={volume}
          url={url}
          playing={(isMobile && isWatching) || isWatching}
          onReady={() => {
            handleVolume();
            setIsWatching(false);
          }}
          onBufferEnd={() => setIsWatching(true)}
          onPlay={() => setIsWatching(true)}
          onPause={() => setIsWatching(false)}
        />
      </div>
    </>
  );
};

export default Player;
